<template>
    <div class="FM_tiXian">
        <!-- 充值 -->
        <el-dialog
            title="提现"
            :visible="tiXianIsShow"
            @close="handleClose"
            :close-on-click-modal="false"
        >
            <el-card class="box-card" shadow="hover">
                <el-form label-position="left" label-width="100px" :model="topUpForm">
                    <div class="purseTitle">
                        <div>提现信息</div>
                    </div>
                    <el-form-item label="提现银行：">
                        <el-select
                            size="medium"
                            v-model="topUpForm.bank_id"
                            style="width:405px"
                            placeholder="请选择提现银行卡"
                        >
                            <el-option
                                v-for="(item,index) in selectbank"
                                :key="index"
                                :label="item.bank_name+' | '+item.bank_code"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="提现金额">
                        <el-input v-model="topUpForm.money" placeholder="请输入提现金额" onblur="this.value=this.value.replace(/[^0-9-]+/,'');">
                            <span slot="suffix" style="font-size:12px">元</span>
                        </el-input>
                    </el-form-item>
                    <div style="margin-top:20px">
                        <el-button
                            type="primary"
                            size="medium"
                            @click="submit(topUpForm)"
                            :loading="submitLoading"
                            style="font-size:12px"
                        >提交审核</el-button>
                        <el-button
                            type="primary"
                            size="medium"
                            @click="cancel"
                            style="font-size:12px"
                        >取消</el-button>
                    </div>
                </el-form>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "FM_tiXian",
    props: {
        tiXianIsShow: {
            type: Boolean,
            default: false
        },
        tiXiantype:{
            type: Number
        }
    },
    data() {
        return {
            selectbank:{},
            dialogIsShow: false,
            submitLoading: false,
            topUpForm: { //提交表单
                money: '',
                account_type: this.tiXiantype,
                bank_id: ''
            },
        }
    },
    mounted() {
        this.getbanks();
    },
    methods: {
        submit(topUpForm) {
            this.$api.post('user/withdraw', topUpForm, res => {
                if (res.code == 0) {
                    let that = this;
                    this.$message({
                        type: 'success',
                        message: res.msg,
                        duration: 2000,
                        onClose() {
                            that.handleClose(1);
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        cancel() {
            this.handleClose(); //取消
        },
        handleClose() {
            this.$emit('tiXianClose')
        },
        getbanks() { //获取支付方式
            this.$api.post('user/bank_lists', {}, res => {
                if (res.code == 0) {
                    this.selectbank = res.data;
                } else {
                //     this.$message.error(res.msg);
                }
            })
        },
    }
};
</script>

<style lang="scss" scope>
.FM_tiXian {
    .purseTitle {
        font-size: 12px;
        margin: 10px 0;
        color: #909399;
        :nth-child(1) {
            font-weight: 700;
            color: #7f7f7f;
            padding-left: 10px;
            border-left: 4px solid #909399;
        }
    }
    .rowTitle {
        color: #909399;
        font-size: 12px;
        .el-col {
            margin: 5px 0;
        }
        .labels {
            font-weight: 700;
        }
    }

    .el-input__inner {
        font-size: 12px;
    }
    .el-form-item {
        .el-form-item__label {
            font-size: 12px;
            font-weight: 700;
        }
        // margin-bottom: 5px;
    }
    .el-dialog {
        min-width: 500px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        background-color: #fdfdfd;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 40px;
        color: #8c939d;
        width: 300px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
    .avatar {
        width: 300px;
        height: 200px;
        display: block;
    }
    // .el-dialog {
    //     display: flex;
    // flex-direction: column;
    // margin: 0 !important;
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    // // height:600px;
    // max-height: calc(100% - 30px);
    // max-width: calc(100% - 30px);
    // }
    // .el-dialog .el-dialog__body {
    //     flex: 1;
    //     overflow: auto;
    // }
}
</style>
